import { step01Win } from "./step_01_win";
import { step02Win } from "./step_02_win";
import { step03Win } from "./step_03_win";
import type { GambleFlow } from "@slot/game-shell";

/** Three wins then terminates. Exercises the chained-win path. */
export const flowTripleWin: GambleFlow = [step01Win, step02Win, step03Win];
